<template>
  <footer class="footer" id="footer">
    <div class="container">
      <div class="social-icons">
        <a href="https://www.facebook.com/Beach-Built-Bootcamp-602958346756789/" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>logo facebook</title><g class="nc-icon-wrapper"><path id="White_4_" fill="#39579A" d="M46,48c1.10457,0,2-0.89543,2-2V2c0-1.10457-0.89543-2-2-2H2C0.89543,0,0,0.89543,0,2v44 c0,1.10457,0.89543,2,2,2H46z"/> <path id="White_2_" fill="#FFFFFF" d="M25.51917,48V29H19v-7l6.51917,0v-5.17462c0-6.19977,3.78661-9.57566,9.31723-9.57566 c2.64922,0,4.92609,0.19724,5.58964,0.2854v6.47912l-3.83578,0.00174C33.5824,14.01598,33,15.44527,33,17.54265V22h7l-1,7h-6v19 H25.51917z"/></g></svg>
        </a>
        <a href="https://www.instagram.com/beachbuiltbootcamp" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>logo instagram</title><g class="nc-icon-wrapper"><path fill="#E02D69" d="M24,0c-6.518,0-7.335,0.028-9.895,0.144c-3.9,0.178-7.326,1.133-10.077,3.884 c-2.75,2.75-3.706,6.175-3.884,10.077C0.028,16.665,0,17.482,0,24c0,6.518,0.028,7.335,0.144,9.895 c0.178,3.9,1.133,7.326,3.884,10.077c2.75,2.75,6.175,3.706,10.077,3.884C16.665,47.972,17.482,48,24,48s7.335-0.028,9.895-0.144 c3.899-0.178,7.326-1.133,10.077-3.884c2.75-2.75,3.706-6.175,3.884-10.077C47.972,31.335,48,30.518,48,24s-0.028-7.335-0.144-9.895 c-0.178-3.9-1.133-7.326-3.884-10.077c-2.75-2.75-6.175-3.706-10.077-3.884C31.335,0.028,30.518,0,24,0L24,0z"/> <path fill="#FFFFFF" d="M24,10.883c4.272,0,4.778,0.016,6.465,0.093c1.821,0.083,3.511,0.448,4.811,1.748 c1.3,1.3,1.665,2.99,1.748,4.811c0.077,1.687,0.093,2.193,0.093,6.465s-0.016,4.778-0.093,6.465 c-0.083,1.821-0.448,3.511-1.748,4.811c-1.3,1.3-2.99,1.665-4.811,1.748c-1.687,0.077-2.193,0.093-6.465,0.093 s-4.778-0.016-6.465-0.093c-1.821-0.083-3.511-0.448-4.811-1.748c-1.3-1.3-1.665-2.99-1.748-4.811 c-0.077-1.687-0.093-2.193-0.093-6.465s0.016-4.778,0.093-6.465c0.083-1.821,0.448-3.511,1.748-4.811 c1.3-1.3,2.99-1.665,4.811-1.748C19.222,10.899,19.728,10.883,24,10.883 M24,8c-4.345,0-4.89,0.018-6.597,0.096 c-2.6,0.119-4.884,0.756-6.718,2.589c-1.833,1.833-2.47,4.117-2.589,6.718C8.018,19.11,8,19.655,8,24 c0,4.345,0.018,4.89,0.096,6.597c0.119,2.6,0.756,4.884,2.589,6.718c1.833,1.833,4.117,2.47,6.718,2.589 C19.11,39.982,19.655,40,24,40s4.89-0.018,6.597-0.096c2.6-0.119,4.884-0.756,6.718-2.589c1.833-1.833,2.47-4.117,2.589-6.718 C39.982,28.89,40,28.345,40,24s-0.018-4.89-0.096-6.597c-0.119-2.6-0.756-4.884-2.589-6.718c-1.833-1.833-4.117-2.47-6.718-2.589 C28.89,8.018,28.345,8,24,8L24,8z"/> <path fill="#FFFFFF" d="M24,15.784c-4.538,0-8.216,3.679-8.216,8.216s3.679,8.216,8.216,8.216 s8.216-3.679,8.216-8.216S28.538,15.784,24,15.784z M24,29.333c-2.946,0-5.333-2.388-5.333-5.333c0-2.946,2.388-5.333,5.333-5.333 c2.946,0,5.333,2.388,5.333,5.333C29.333,26.946,26.946,29.333,24,29.333z"/> <circle fill="#FFFFFF" cx="32.541" cy="15.459" r="1.92"/></g></svg>
        </a>
      </div>
      <div class="text-center">
        <p>&copy; {{currentYear}} Beach-Built.com</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    currentYear: () => {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/variables';
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.footer {
  padding: 40px 0;

  .social-icons {
    margin: 0 0 30px 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;

    a {
      width: 40px;
      height: 40px;
      margin: 0 15px;
    }
  }

  p {
    &:last-child {
      margin: 0;
    }
  }
}
</style>
